import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { postPayment, postTicketCreate } from "connection/backend";
import SweetAlert from "react-bootstrap-sweetalert";
import Loader from "../../../components/Common/Loader";

const PaymentModal = (props) => {
  const history = useHistory();
  const redirect = () => {
    history.push("/tickets");
  };

  const [loading, setLoading] = useState(false);
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState(false);
  const [value, setValue] = useState("");
  const [payment_date, setPaymentDate] = useState("");
  const [payment_type, setPaymentType] = useState("2");
  const [payment_number, setPaymentNumber] = useState("");
  const [formData, setFormData] = useState({
    payment_method: "efectivo",
    bank: "banco_1",
  });
  const { payment_method, bank } = formData;

  const onChange = (e) => {
    if (e.target.name === "value") {
      const valor = e.target.value;
      let formattedValue = valor
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      if (props.ticket != null){
        const debt = parseInt(props.ticket.total) - parseInt(props.ticket.value_paid);
        if (parseInt(formattedValue.replace(/\./g, "")) > debt){
          const debt_string = String(debt);
          let debt_value = debt_string
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          setValue(debt_value);
        } else {
          setValue(formattedValue);
        }
      } else {
        setValue(formattedValue);
      }
    } else if (e.target.name === "payment_date") {
      setPaymentDate(e.target.value);
    } else if (e.target.name === "payment_type") {
      setPaymentType(e.target.value);
    } else if (e.target.name === "payment_number") {
      setPaymentNumber(e.target.value);
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      client_code: props.client,
      ticket: props.ticket ? props.ticket.code : null,
      payment_method: payment_method,
      payment_date: payment_method !== "efectivo" ? payment_date : "2000-01-01",
      payment_type: payment_method !== "efectivo" ? payment_type : "1",
      payment_number: payment_number,
      bank: payment_method !== "efectivo" ? bank : "no_aplica",
      value: parseInt(value.replace(/\./g, "")),
    };
    postPay(data);
  };

  const postPay = async (data) => {
    setLoading(true);
    const response = await postPayment(data);
    if (response.status === 201) {
      setAlertSuccess(true);
    } else {
      setAlertError(true);
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        centered={true}
        size="lg"
      >
        <ModalHeader>
          {props.ticket
            ? `Pago de ticket - ${props.ticket.consecutive}`
            : "Abono"}
        </ModalHeader>
        <ModalBody>
          {props.ticket ? (
            <>
              <Row className="d-flex justify-content-center mb-4">
                <Col
                  lg={4}
                  className="d-flex justify-content-center font-size-16"
                >
                  <b>Consecutivo:</b>&nbsp;{props.ticket.consecutive}
                </Col>
                <Col
                  lg={3}
                  className="d-flex justify-content-center font-size-16"
                >
                  <b>Total:</b>&nbsp;$ 
                  {props.ticket.total.toLocaleString("es-CO")}
                </Col>
                <Col
                  lg={4}
                  className="d-flex justify-content-center font-size-16"
                >
                  <b>Valor pagado:</b>&nbsp;$ 
                  {props.ticket.value_paid.toLocaleString("es-CO")}
                </Col>
              </Row>
              <hr />
              <Form onSubmit={onSubmit}>
                <Row className="justify-content-md-center mb-2">
                  <Col lg={5} className="font-size-16 mb-2">
                    <b>Medio de pago: </b>
                    <select
                      className="form-select"
                      id="payment_method"
                      name="payment_method"
                      value={payment_method}
                      onChange={onChange}
                    >
                      <option value="efectivo">Efectivo</option>
                      <option value="consignacion">Consignación</option>
                      <option value="cheque">Cheque</option>
                    </select>
                  </Col>
                  {payment_method !== "efectivo" ? (
                    <>
                      <Col lg={5} className="font-size-16 ">
                        <b>Entidad: </b>
                        <select
                          className="form-select"
                          id="bank"
                          name="bank"
                          value={bank}
                          onChange={onChange}
                        >
                          <option value="banco_1">Banco de Bogotá</option>
                          <option value="banco_2">Bancolombia</option>
                        </select>
                      </Col>
                      <Col lg={5} className="font-size-16 mb-2">
                        <b>Fecha de consignación: </b>
                        <Input
                          type="date"
                          id="payment_date"
                          name="payment_date"
                          value={payment_date}
                          onChange={onChange}
                        />
                      </Col>
                      <Col lg={5} className="font-size-16 mb-2">
                        <b>Tipo: </b>
                        <select
                          className="form-select"
                          id="payment_type"
                          name="payment_type"
                          value={payment_type}
                          onChange={onChange}
                        >
                          <option value="2">Consignación corresponsal bancario</option>
                          <option value="3">Transferencia cta Sucursal Virtual</option>
                          <option value="4">Transferencia Nequi</option>
                          <option value="5">Transferencia Banca Móvil</option>
                        </select>
                      </Col>
                      <Col lg={5} className="font-size-16 mb-2">
                        <b>Número de recibo: </b>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Ingrese el valor..."
                          name="payment_number"
                          id="payment_number"
                          value={payment_number}
                          onChange={onChange}
                          required
                        />
                      </Col>
                    </>
                  ) : null}
                  <Col lg={5} className="font-size-16 mb-2">
                    <b>Abono: </b>
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Ingrese el valor..."
                      name="value"
                      id="value"
                      value={value}
                      onChange={onChange}
                      required
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} className="d-flex justify-content-end">
                    <Button color="primary" className="btn me-2" type="submit">
                      Registrar abono
                    </Button>
                    <Button color="secondary" onClick={() => props.toggle()}>
                      Cerrar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          ) : (
            <Form onSubmit={onSubmit}>
              <Row className="justify-content-md-center mb-2">
                <Col lg={5} className="font-size-16 mb-2">
                  <b>Medio de pago: </b>
                  <select
                    className="form-select"
                    id="payment_method"
                    name="payment_method"
                    value={payment_method}
                    onChange={onChange}
                  >
                    <option value="efectivo">Efectivo</option>
                    <option value="consignacion">Consignación</option>
                    <option value="cheque">Cheque</option>
                  </select>
                </Col>
                {payment_method !== "efectivo" ? (
                  <>
                    <Col lg={5} className="font-size-16">
                      <b>Entidad: </b>
                      <select
                        className="form-select"
                        id="bank"
                        name="bank"
                        value={bank}
                        onChange={onChange}
                      >
                        <option value="banco_1">Banco de Bogotá</option>
                        <option value="banco_2">Bancolombia</option>
                      </select>
                    </Col>
                    <Col lg={5} className="font-size-16 mb-2">
                      <b>Fecha de consignación: </b>
                      <Input
                        type="date"
                        id="payment_date"
                        name="payment_date"
                        value={payment_date}
                        onChange={onChange}
                      />
                    </Col>
                    <Col lg={5} className="font-size-16 mb-2">
                      <b>Tipo: </b>
                      <select
                        className="form-select"
                        id="payment_type"
                        name="payment_type"
                        value={payment_type}
                        onChange={onChange}
                      >
                        <option value="2">Consignación corresponsal bancario</option>
                        <option value="3">Transferencia cta Sucursal Virtual</option>
                        <option value="4">Transferencia Nequi</option>
                        <option value="5">Transferencia Banca Móvil</option>
                      </select>
                    </Col>
                    <Col lg={5} className="font-size-16 mb-2">
                      <b>Número de recibo: </b>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Ingrese el valor..."
                        name="payment_number"
                        id="payment_number"
                        value={payment_number}
                        onChange={onChange}
                        required
                      />
                    </Col>
                  </>
                ) : null}
                <Col lg={5} className="font-size-16 mb-2">
                  <b>Abono: </b>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Ingrese el valor..."
                    name="value"
                    id="value"
                    value={value}
                    onChange={onChange}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12} className="d-flex justify-content-end">
                  <Button color="primary" className="btn me-2" type="submit">
                    Registrar abono
                  </Button>
                  <Button color="secondary" onClick={() => props.toggle()}>
                    Cerrar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </ModalBody>
        {/* Alerts */}
        <SweetAlert
          title="¡Hecho!"
          success
          showConfirm={true}
          show={alertSuccess}
          onConfirm={() => {
            props.setRender(!props.render);
            setAlertSuccess(false);
            props.toggle();
          }}
        >
          {props.ticket
            ? "El abono/pago del ticket se ha registrado correctamente."
            : "El abono se ha registrado correctamente"}
        </SweetAlert>
        <SweetAlert
          title="¡Error!"
          danger
          showConfirm={true}
          show={alertError}
          onConfirm={() => {
            setAlertError(false);
          }}
        >
          Ocurrió un error al registrar el abono/pago, intente nuevamente.
        </SweetAlert>
      </Modal>
    </>
  );
};

export default PaymentModal;
